<template>
  <div @mouseenter="onMouseEnter" @mouseleave="onMouseLeave">
    <pb-cascader-panel
      class="gtr-cascader-panel"
      :style="{ top, left }"
      :props="{ expandTrigger: 'hover' }"
      :options="options || []"
      @change="handleChange"
    >
    </pb-cascader-panel>
  </div>
</template>

<script>
import { useMenuStore } from '@/store';
import { transformToPanelData } from '@/utils/utils';
export default {
  props: {
    panelData: {
      type: Object,
      default: () => {
        return { event: {}, item: {} };
      },
    },
  },
  data() {
    return {
      left: '0px',
      top: '0px',
      options: [],
    };
  },
  mounted() {
    const menuStore = useMenuStore();
    const { event, item } = this.panelData;
    // 获取当前hover菜单ID
    const nodeId = item?.meta?.nodeId;
    // 获取当前hover菜单数据
    const topList = menuStore.routeList.find((item) => item.meta.nodeId === +nodeId);
    // 过滤掉hidden菜单（第一项重定向数据、/gtr_xxx/*）
    const topMenuList = topList?.children?.filter((item) => !item.hidden);
    // 格式转换
    this.options = transformToPanelData(topMenuList);
    // 级联面板定位
    this.left = event.clientX - event.offsetX - 16 + 'px';
    // 兼容顶部导航滚动后遮住区域顶部定位
    this.top =
      event.clientY >= event.offsetY ? event.clientY + 48 - event.offsetY + 'px' : 55 + 'px';
  },
  methods: {
    // 进入级联导航时 取消定时器
    onMouseEnter() {
      this.$emit('onMouseEnter');
    },
    onMouseLeave() {
      this.$emit('onMouseLeave');
    },
    handleChange(val) {
      this.$emit('handleChange', val);
    },
  },
};
</script>

<style lang="scss" scoped>
.gtr-cascader-panel {
  position: absolute;
  z-index: 999;
  background-color: #fff;
  :deep(.pb-cascader-menu__wrap) {
    height: 300px;
  }
}
</style>
